import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FacturaDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Folio", cell: x => ({ data: x.SerieFolio }) },
    { title: "Cliente", cell: x => ({ data: x.NombreCliente }) },
    { title: "Pagada", cell: x => ({ data: x.EsPPDPagada }) },
    { title: "Cancelado", cell: x => ({ data: x.EsCancelada }) },
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Sucursal de cobranza", cell: x => ({ data: x.NombreSucursalCobranza }) },
    //{ title: "Saldo", cell: x => ({ data: x.Saldo, view: kea.formatCurrency }) },
    { title: "Saldo", cell: x => ({ data: x.Calculo6Decimales ?  "$"+ x.Saldo.toFixed(2) :kea.formatCurrency(x.Saldo) }) },
    //{ title: "Total", cell: x => ({ data: x.ImporteTotal, view: kea.formatCurrency }) },
    { title: "Total", cell: x => ({ data: x.Calculo6Decimales ?  "$"+ x.ImporteTotal.toFixed(2) :kea.formatCurrency(x.ImporteTotal) }) },
    { title: "Subtotal", cell: x => ({ data: kea.formatCurrency(x.ImporteSubtotal) }) },
    { title: "IVA", cell: x => ({ data: x.Calculo6Decimales ?  "$"+ x.TotalIVA.toFixed(2) :kea.formatCurrency(x.TotalIVA) }) },
    //{ title: "Retenciones", cell: x => ({ data: x.TotalRetencionIVA }) },
    { title: "Retenciones", cell: x => ({ data: x.Calculo6Decimales ?  "$"+ x.TotalRetencionIVA.toFixed(2) :kea.formatCurrency(x.TotalRetencionIVA) }) },
    { title: "REPs", cell: x => ({ data: x.FolioReps }) },
    { title: "Fecha de pago", cell: x => ({ data: kea.toDate(x.FechaPago) }) },
    { title: "Pagada sin REP", cell: x => ({ data: x.PagadaSinRep }) },
    { title: "PUE pero crédito", cell: x => ({ data: x.PuePeroCredito }) },
    { title: "PPD pero contado", cell: x => ({ data: x.PpdPeroContado }) },
];

export interface BotonesDeps {
    onVer: (x: Entity) => void;
    onCancelar: (x: Entity) => void;
    onReimprimir: (x: Entity) => void;
    onTimbrar: (x: Entity) => void;
    OnObtenerPDF: (x: Entity) => void;
    OnObtenerPDFDetalleCobranza: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): Column[] {
    const botones = kea.columnaBotones<Entity>([
        {
            iconClass: fa("eye", "fw"),
            onClick: deps.onVer,
            tooltip: "Ver"
        }, {
            iconClass: fa("times", "fw"),
            onClick: deps.onCancelar,
            tooltip: "Cancelar factura"
        }, {
            iconClass: fa("bell", "fw"),
            style: "warning",
            onClick: deps.onTimbrar,
            tooltip: "Timbrar factura",
            disabled: x => x.EsTimbrada || x.EsCancelada
        }, {
            iconClass: fa("file-pdf-o", "fw"),
            style: "danger",
            onClick: deps.OnObtenerPDF,
            tooltip: "Obtener comprobante",
            disabled: x => !(x.EsTimbrada && !x.EsCancelada)
        }, {
            iconClass: fa("file-pdf-o", "fw"),
            style: "info",
            onClick: deps.OnObtenerPDFDetalleCobranza,
            tooltip: "Obtener reporte detalle cobranza",
            disabled: x => x.EsCancelada
        }


    ]);

    const cols = [botones, ...columnasFijas];
    return kea.applyRowStyleToColumns(cols, x => ({
        background:
            x.EsCancelada ? "rgba(255,0,0,0.3)" :
                !x.EsTimbrada ? "rgba(255,255,0,0.3)" :
                    !x.EsPPDPagada ? "rgba(0,0,255,0.15)" :
                        undefined
    }));
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/list/columns.tsx